<template>
  <div class="ja-activity-view">
    <div class="ja-activity-view__kpis">
      <div
        v-for="kpi in data.kpis"
        :key="kpi.title"
        class="ja-activity-view__kpi"
        :class="{ 'ja-activity-view__kpi--highlight': kpi.highlight }"
      >
        <div class="ja-activity-view__kpi-body">
          <div class="ja-activity-view__kpi-header">
            <div
              class="ja-activity-view__kpi-icon-wrap"
              :style="iconWrapStyle(kpi)"
            >
              <feather-icon
                :icon="kpi.icon"
                svgClasses="ja-activity-view__kpi-icon"
                :style="iconStyle(kpi)"
              />
            </div>
            <span class="ja-activity-view__kpi-title">{{ kpi.title }}</span>
          </div>
          <div class="ja-activity-view__kpi-value">{{ kpi.value }}</div>
        </div>
      </div>
    </div>

    <div class="ja-activity-view__charts">
      <div class="ja-activity-view__col">
        <daily-activity-trend
          :categories="data.dailyTrend.categories"
          :opens="data.dailyTrend.opens"
          :pay-now-clicks="data.dailyTrend.payNowClicks"
          :payments="data.dailyTrend.payments"
        />
      </div>
      <div class="ja-activity-view__col">
        <action-mix-chart
          :actions="data.actionMix"
          :total-actions="data.totalActions"
        />
      </div>
    </div>

    <business-metrics :metrics="data.businessMetrics" />
  </div>
</template>

<script>
import DailyActivityTrend from "./DailyActivityTrend.vue";
import ActionMixChart from "./ActionMixChart.vue";
import BusinessMetrics from "./BusinessMetrics.vue";

export default {
  name: "ActivityView",
  components: {
    DailyActivityTrend,
    ActionMixChart,
    BusinessMetrics,
  },
  props: {
    data: { type: Object, required: true },
  },
  methods: {
    iconWrapStyle(kpi) {
      if (kpi.highlight) {
        return { background: "rgba(255, 255, 255, 0.18)" };
      }

      return { background: this.hexToRgba(kpi.color, 0.12) };
    },
    iconStyle(kpi) {
      if (kpi.highlight) {
        return { color: "#fff" };
      }

      return { color: kpi.color };
    },
    hexToRgba(hex, alpha) {
      const normalized = hex.replace("#", "");
      const value = normalized.length === 3
        ? normalized.split("").map((c) => c + c).join("")
        : normalized.slice(0, 6);
      const r = parseInt(value.slice(0, 2), 16);
      const g = parseInt(value.slice(2, 4), 16);
      const b = parseInt(value.slice(4, 6), 16);

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};
</script>

<style scoped lang="scss">
.ja-activity-view {
  &__kpis {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
    margin-bottom: 1.5rem;

    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 640px) {
      grid-template-columns: 1fr;
    }
  }

  &__kpi {
    width: 100%;
    min-height: 127.5px;
    box-sizing: border-box;
    padding: 1.25rem 1.35rem;
    border-radius: 18px;
    border: 1px solid #ececf2;
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(20, 21, 34, 0.04);

    &--highlight {
      background: linear-gradient(128.53deg, #0f9d58 0%, #16a34a 100%);
      border-color: transparent;

      .ja-activity-view__kpi-title,
      .ja-activity-view__kpi-value {
        color: #fff;
      }
    }
  }

  &__kpi-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: calc(127.5px - 2.5rem);
  }

  &__kpi-header {
    display: flex;
    align-items: flex-start;
    gap: 0.65rem;
    min-height: 36px;
  }

  &__kpi-icon-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    flex-shrink: 0;
  }

  &__kpi-icon {
    width: 18px;
    height: 18px;
  }

  &__kpi-title {
    flex: 1;
    min-width: 0;
    padding-top: 0.45rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    line-height: 1.25;
  }

  &__kpi-value {
    margin-top: auto;
    padding-top: 1.25rem;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 30px;
    font-weight: 800;
    font-style: normal;
    line-height: 100%;
    letter-spacing: -0.6px;
    color: #16172b;
  }

  &__charts {
    display: grid;
    grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);
    gap: 1rem;
    align-items: stretch;
    margin-bottom: 1.5rem;

    @media (max-width: 992px) {
      grid-template-columns: 1fr;
    }
  }

  &__col {
    min-width: 0;
  }
}
</style>
